// extracted by mini-css-extract-plugin
export default {"paymentInfoWrapper":"styles_paymentInfoWrapper__RXDh3","buttonWrapper":"styles_buttonWrapper__nm1fI"};